export enum ProformaErrorsEnum {
  CONTRACT_STATUS_EXPIRED= 'CONTRACT_STATUS_EXPIRED',
  CONTRACT_STATUS_INVALID= 'CONTRACT_STATUS_INVALID',
  INVALID_LEGAL_DOCUMENTS = 'INVALID_LEGAL_DOCUMENTS',
  TAX_AMOUNT_INVALID= 'TAX_AMOUNT_INVALID',
  TAXLESS_TOTAL_INVALID= 'TAXLESS_TOTAL_INVALID',
  TOTAL_INCLUDING_TAX_INVALID= 'TOTAL_INCLUDING_TAX_INVALID',
  TAX_GROUP_INVALID = 'TAX_GROUP_INVALID'
}
